import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,

  FormGroup,

  Validators,
} from '@angular/forms';


import { first } from 'rxjs';
import { CustomValidators } from '../../validators/customValidators';
import { Admin } from '../../services/admin';
import { Auth } from '../../services/auth';
import { Router } from '@angular/router';
import { SuccessDialog } from '../../pages/common-features/success-dialog/success-dialog';
import { MatDialog } from '@angular/material/dialog';
import { inject } from '@angular/core/primitives/di';

@Component({
  selector: 'app-forget-password',
  standalone: false,
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.less',
})
export class ForgotPassword implements OnInit {
  submitted: boolean = false;
  loading: boolean = false;
  requestPinFormSubmitted: boolean = false;
  emailSent: boolean = false;
  showError: boolean = false;
  sendingPin: boolean = false;
  forgotEmailFormGroup!: FormGroup;
  requestPinForm!: FormGroup;
  message: any;
  errorMessage: any;
  passwordRestDone: boolean = false;
  step: number = 1;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  otpDigits: string[] = ['', '', '', ''];
  status:string='';
  constructor(
    private formBuilder: FormBuilder,
    private adminService: Admin,
    private authService: Auth,
    private router: Router,
    private _dialog: MatDialog

  ) { }

  ngOnInit(): void {
    this.forgotEmailFormGroup = this.formBuilder.group({
      emailId: ['', [Validators.required, Validators.email]],
    });

    this.requestPinForm = this.formBuilder.group({
      pin: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      password: [
        '',
        Validators.compose([
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true
          }),
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true
          }),
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true
          }),
          Validators.minLength(8),
          Validators.required,
        ])
      ],
      confirmPassword: ['', Validators.required]
    }, { validators: CustomValidators.passwordMatchValidator });
    this.clearServerMessages();
  }

  get f() {
    return this.forgotEmailFormGroup.controls;
  }

  get requestPinFormControls() {
    return this.requestPinForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    const formData = {
      "mobileNumber": this.forgotEmailFormGroup.value.emailId,
      "password": "",
      "pin": ""
    }
    console.log(formData);
    if (this.forgotEmailFormGroup.valid) {
      this.loading = true;
      this.authService.getPin(formData)
        .pipe()
        .subscribe({
          next: (data: any) => {
            this.message = data.status;
            console.log(this.message);
            if (this.message && this.message.trim() !== '') {
              // setTimeout(() => {
              this.emailSent = true;
              this.loading = false;
              this.step = 2; // Transition to OTP step
              // }, 10000);
            }
          }, error: (error: any) => {
            console.log(JSON.stringify(error.error));
            this.errorMessage = JSON.stringify(error.error.error);
            this.loading = false;
            this.showError = true;
            this.forgotEmailFormGroup.get('emailId')?.setErrors({ serverError: JSON.stringify(error.error.error) });

          }
        })

    }

  }

  onRequestPinFormSubmit() {
    this.requestPinFormSubmitted = true;
    this.showError = false;

    // Step 2 Logic: Only validate PIN
    if (this.step === 2) {
      if (this.requestPinFormControls['pin'].invalid) {
        this.showError = true;
        this.errorMessage = 'Please enter a valid 4-digit PIN';
        return;
      }
      // Transition to Step 3
      this.step = 3;
      this.requestPinFormSubmitted = false;
      return;
    }

    // Step 3 Logic: Validate full form
    if (this.step === 3) {
      if (this.requestPinForm.invalid) {
        this.showError = true;
        this.errorMessage = 'Password don\'t match the requirement';
        return;
      }

      this.sendingPin = true;
      const formData = {
        "mobileNumber": this.forgotEmailFormGroup.value.emailId,
        "password": this.requestPinForm.value.password,
        "pin": this.requestPinForm.value.pin
      }

      this.authService.forgotPassword(formData)
        .pipe(first())
        .subscribe({
          next: (data: any) => {
            console.log(data);
            // this.toastrService.success(JSON.stringify(data.status));
            this.message = JSON.stringify(data.status);
            this.passwordRestDone = true;
            this.status = 'success';
            this.sendingPin = false;
            this.showSuccessDialogComponent('Password Changed','Your password has been changed successfully','success');
            // Step logic: If Step 2 (OTP) is verified, move to Step 3 (Reset Password).
            if (this.step === 2) {
              this.step = 3;
              this.requestPinFormSubmitted = false;
              this.showError = false;
              
            }
          }, error: (error: any) => {
            console.log(error);
            // this.toastrService.error(error.error.error);
            this.errorMessage = JSON.stringify(error.error.error);
            this.sendingPin = false;
            this.showError = true;
            this.status = 'error';
            this.showSuccessDialogComponent('Oops something went wrong',this.errorMessage,'error');


          }
        })
    }

  }

  clearServerMessages() {
    // Listen to Step 1 Form
    Object.keys(this.forgotEmailFormGroup.controls).forEach(field => {
      const control = this.forgotEmailFormGroup.get(field);
      control?.valueChanges.subscribe(() => {
        this.showError = false;
        this.submitted = false;
        const errors = { ...control.errors };
        if (errors && errors['serverError']) {
          delete errors['serverError'];
          control.setErrors(Object.keys(errors).length ? errors : null);
        }
      });
    });

    // Listen to Step 2 & 3 Form
    Object.keys(this.requestPinForm.controls).forEach(field => {
      const control = this.requestPinForm.get(field);
      control?.valueChanges.subscribe(() => {
        this.showError = false;
        this.requestPinFormSubmitted = false;
        const errors = { ...control.errors };
        if (errors && errors['serverError']) {
          delete errors['serverError'];
          control.setErrors(Object.keys(errors).length ? errors : null);
        }
      });
    });
  }

  landingPage() {
    this.router.navigate(['/login']);
  }

  goToStep(step: number) {
    this.step = step;
    this.showError = false;
  }

  onOtpChange(event: any, index: number) {
    const val = event.target.value;
    this.showError = false;
    this.requestPinFormSubmitted = false;
    if (val.length === 1 && index < 3) {
      const nextInput = event.target.nextElementSibling;
      if (nextInput) nextInput.focus();
    }
    this.otpDigits[index] = val;
    this.requestPinForm.patchValue({ pin: this.otpDigits.join('') });
  }

  onOtpKeyDown(event: any, index: number) {
    if (event.key === 'Backspace' && !event.target.value && index > 0) {
      const prevInput = event.target.previousElementSibling;
      if (prevInput) prevInput.focus();
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  resendOtp() {
    this.onSubmit();
  }

   showSuccessDialogComponent(title:string,message:string,icon:string){
        const dialog = this._dialog.open(SuccessDialog,{
          data:{
            title:title,
            subtitle:message,
            icon:icon
          },
           height: '400px',
           width: '500px',
          panelClass: 'custom-dialog-container'
        })
        dialog.afterClosed().subscribe((result:any)=>{
          if(this.status == 'success'){
            this.router.navigate(['/login']);
          }else{
            
          }
        })
      }
}
